import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { DISCLAIMER_AUTO_HIDE_SECONDS } from "utils/constants";
import { Color } from "utils/theme";
import { useStore } from "hooks/use-store";
import { Button } from "components/ui/button";
import { Modal } from "components/ui/modal";
import { useLocalStorage } from "hooks/use-local-storage";

export const Disclaimer = () => {
  const { t } = useTranslation("translation", { keyPrefix: "disclaimer" });
  const [counter, setCounter] = useState<number>(DISCLAIMER_AUTO_HIDE_SECONDS);
  const tripId = useStore((state) => state.tripId);
  const showDisclaimer = useStore((state) => state.showDisclaimer);
  const setShowDisclaimer = useStore((state) => state.setShowDisclaimer);

  // Local storage to remember agreed trip ID
  const [disclaimerTripId, setDisclaimerTripId] = useLocalStorage(
    "disclaimer_agree_trip_id",
    null
  );

  // Auto-hide if already agreed for this trip
  useEffect(() => {
    if (tripId && disclaimerTripId === tripId) {
      setShowDisclaimer(false);
    }
  }, [tripId, disclaimerTripId, setShowDisclaimer]);

  // Run the countdown only while the disclaimer is shown
  useEffect(() => {
    if (!showDisclaimer) return;

    const intervalId = setInterval(() => {
      setCounter((count) => count - 1);
    }, 1000);

    return () => {
      clearInterval(intervalId);
      setCounter(DISCLAIMER_AUTO_HIDE_SECONDS);
    };
  }, [showDisclaimer]);

  // Auto-hide when timer reaches 0
  useEffect(() => {
    if (counter <= 0 && showDisclaimer) {
      setShowDisclaimer(false);
    }
  }, [counter, showDisclaimer, setShowDisclaimer]);

  const onAgree = () => {
    setShowDisclaimer(false);
    setDisclaimerTripId(tripId);
  };

  return (
    <Modal show={showDisclaimer} title={t("title")} onClose={onAgree}>
      <div className="flex flex-col h-full space-y-3 overflow-hidden">
        <p
          className="text-gray-400 leading-7 max-w-lg overflow-auto"
          style={{ color: Color.Primary[400] }}
        >
          {t("description")}
        </p>
        <div className="w-full shrink-0 mt-2">
          <Button
            className="w-full tabular-nums"
            onClick={onAgree}
            variant="secondary"
          >
            {t("accept_button", { 0: counter })}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
